import { ReactNode } from "react";
import styles from "./menuPanel.module.scss";

export interface MenuItem {
  icon: ReactNode;
  label: string;
  onClick?: () => void;
  href?: string;
  danger?: boolean;
}

export default function MenuRow({ icon, label, onClick, href, danger }: MenuItem): JSX.Element {
  const className = `${styles.row}${danger ? ` ${styles.danger}` : ""}`;
  const content = (
    <>
      <span className={styles.icon}>{icon}</span>
      <span className={styles.label}>{label}</span>
    </>
  );

  if (href) {
    return (
      <a className={className} href={href}>
        {content}
      </a>
    );
  }

  return (
    <button type="button" className={className} onClick={onClick}>
      {content}
    </button>
  );
}
